export const APPLICATION_NAMES = {
    profiles: 'Profiles',
    administration: 'Administration',
    reservationManagement: 'Reservation Management',
    marketplace: 'Resource Marketplace',
    planning: 'Production Planning',
    procurement: 'Procurement',
    guest: 'Guest',
    reservationProfessional: 'Reservation Professional',
    productionProfessional: 'Production Professional',
    lightingProfessional: 'Lighting Professional',
    productionConnect: 'Production Connect',
    globalLanguages: 'Global Languages',
    mcpServer: 'MCP Server',
    dealEssentials: 'Deal Essentials',
    dealOperations: 'Deal Operations',
    dealFinancials: 'Deal Financials'
};
